import React, { memo } from 'react'
import { Alert, AlertTitle, Box, Divider, Grid2, Stack } from '@mui/material'
import { faStar } from '@fortawesome/pro-duotone-svg-icons'

import { buildStatusLabelIcon, getNftCoverImage } from '../../util/nft.helpers'
import Popup from '../shared/popup/Popup'
import RedeemAsset from '../redeem/RedeemAsset'
import { Label } from '../shared/label'
import RedeemTitle from '../redeem/RedeemTitle'
import NftDescription from '../shared/content/NftDescription'
import NftMoreActions from './NftMoreActions'
import customConfig from 'customConfig'
import NftExclusiveContent from './NftExclusiveContent'
import BackButton from '../shared/button/BackButton'
import LearnMoreLink from '../shared/links/LearnMoreLink'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import { Scrollbar } from '../shared/scrollbar'
import { LoadingScreen } from '../shared/loading-screen'

const NftDetails = ({
  onCancel,
  t,
  name,
  metadata,
  nftCount,
  canTransfer,
  canSell,
  onNftActionSelect,
  nftClaimCount,
  cancelListingAction,
  // loading,
  nftProfile: { dynamicExclusiveContent, loadingSale }
}) => {
  const description = metadata?.description?.data
  const link = metadata?.externalLink
  const staticExclusiveContent = metadata?.exclusiveContent
  const { label, icon } = buildStatusLabelIcon(
    staticExclusiveContent || dynamicExclusiveContent,
    nftClaimCount
  )

  return (
    <Popup maxWidth='lg' onCancel={onCancel} disableEnforceFocus>
      <Box sx={{ gap: 1.5, display: 'flex', mb: { xs: 1.5, md: 2 } }}>
        <BackButton onClick={onCancel} t={t} />
        <Box sx={{ flexGrow: 1 }} />
        {(canTransfer || canSell) && !cancelListingAction && (
          <NftMoreActions
            canTransfer={canTransfer}
            canSell={canSell && !cancelListingAction}
            t={t}
            onNftActionSelect={onNftActionSelect}
            loading={loadingSale}
          />
        )}
      </Box>
      <Grid2 container spacing={{ xs: 2, md: 4, lg: 6 }} pb={{ xs: 2, md: 3 }}>
        <Grid2 size={{ xs: 12, md: 5, lg: 7 }}>
          <Box sx={{ borderRadius: 2 }}>
            <RedeemAsset
              isNft
              metadata={metadata}
              image={getNftCoverImage(metadata)}
            />
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 7, lg: 5 }}>
          <Stack spacing={2} sx={{ height: 1 }}>
            <RedeemTitle
              name={name}
              isNft
              iconSize='xl'
              titleProps={{
                variant: 'h5',
                sx: { color: '' },
                noWrap: false
              }}
            />
            <Divider sx={{ borderStyle: 'dashed' }} />
            <Scrollbar
              sx={{
                height: {
                  xs: '100%',
                  md:
                    !cancelListingAction &&
                    !(staticExclusiveContent || dynamicExclusiveContent)
                      ? 450
                      : 332
                }
              }}
            >
              <Stack spacing={2} alignItems='flex-start'>
                {nftCount > 1 && (
                  <Box sx={{ gap: 1, display: 'flex', alignItems: 'center' }}>
                    <Label color='info'>{`x${nftCount}`}</Label>
                  </Box>
                )}

                {description && <NftDescription content={description} t={t} />}
                {link && (
                  <LearnMoreLink
                    label={t(customConfig.openNftLinkLabel)}
                    to={link}
                  />
                )}
              </Stack>
            </Scrollbar>
            <Divider sx={{ borderStyle: 'dashed', flexGrow: 1 }} />
            <Stack
              spacing={2}
              sx={{ position: { xs: 'static', md: 'sticky' } }}
              alignItems='flex-start'
            >
              {cancelListingAction}
              {(staticExclusiveContent || dynamicExclusiveContent) && (
                <Alert
                  severity='warning'
                  sx={{ width: '100%' }}
                  icon={<FaIcon icon={faStar} />}
                >
                  <AlertTitle>{t('common.exclusive-content')}</AlertTitle>
                  <NftExclusiveContent
                    dynamicExclusiveContent={dynamicExclusiveContent}
                    staticExclusiveContent={staticExclusiveContent}
                  />
                  {label && (
                    <Label endIcon={icon} color='primary'>
                      {t('common.exclusive-content')}:{' '}
                      {t(`nft.exclusive-content-status.${label}`)}
                    </Label>
                  )}
                </Alert>
              )}
              {loadingSale && <LoadingScreen />}
            </Stack>
          </Stack>
        </Grid2>
      </Grid2>
    </Popup>
  )
}

export default memo(NftDetails)
